import { render, staticRenderFns } from "./success.vue?vue&type=template&id=5490b969&scoped=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"
import style0 from "./success.vue?vue&type=style&index=0&id=5490b969&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490b969",
  null
  
)

export default component.exports